import { Type } from "@angular/core";

import {
  ActionMode,
  ButtonModel,
  FormButtonType
} from 'src/app/model';

export interface DialogExtrasModel {
  [s: string]: unknown;
}

export interface DialogModel {
  title: string;
  content?: string;
  component?: Type<any>;
  componentInputs?: Record<string, unknown>;
  showClose?: boolean;
  showAction?: boolean;
  actions?: ButtonModel[];
  extras?: DialogExtrasModel;
}

export interface DialogArgsModel extends DialogExtrasModel {
  type?: FormButtonType;
  actionType?: ActionMode;
}
